<template>
	<div id="app">
		<div class="left">
			<div class="header">
				<div class="top-box" @click="jump('yuexinzengmd')">
					<img src="/static/qmsj/img/genjin/1.png" />
					<div class="top-txt">{{list.xzmd ? list.xzmd : '--'}}</div>
					<div class="down-txt">{{list.yue ? list.yue : '--'}}月新增名单</div>
				</div>
				<div class="top-box" @click="jump('yuegenjinjl')">
					<img src="/static/qmsj/img/genjin/2.png" />
					<div class="top-txt">{{list.gjjl ? list.gjjl : '--'}}</div>
					<div class="down-txt">{{list.yue ? list.yue : '--'}}月跟进记录</div>
				</div>
				<div class="top-box" @click="jump('mingdanzs')">
					<img src="/static/qmsj/img/genjin/3.png" />
					<div class="top-txt">{{list.mdzs ? list.mdzs : '--'}}</div>
					<div class="down-txt">名单总数</div>
				</div>
				<div class="top-box" @click="jump('hetongs')">
					<img src="/static/qmsj/img/genjin/4s.png" />
					<div class="top-txt">{{list.hts ? list.hts : '--'}}</div>
					<div class="down-txt">{{list.yue ? list.yue : '--'}}月合同数</div>
				</div>
				<div class="top-box" @click="jump('hetongje')">
					<img src="/static/qmsj/img/genjin/4.png" />
					<div class="top-txt">{{list.htje ? list.htje : '--'}}</div>
					<div class="down-txt">{{list.yue ? list.yue : '--'}}月合同金额</div>
				</div>
			</div>

			<div class="three-box">
				<div id="main" class="main" ></div>
			</div>
			<div class="two-box">
				<div style="width: 70%;" @click="jump('qjinjigj')">
					<img src="/static/qmsj/img/genjin/5.png" />
					<div class="num">{{list.qjjgj}}</div>
					<span class="txt">今日紧急跟进名单</span>
					<div class="left-top">潜客</div>
				</div>
				<span @click="jump('qwangqigj')" style="position: absolute;top: 20px;right: 20px;color: white;">往期待跟进</span>
			</div>
			<div class="three-box">
				<div id="main2" class="main" ></div>
			</div>
			<div class="two-box" style="background: rgb(255, 185, 123);">
				<div style="width: 70%;" @click="jump('vjinjigj')">
					<img src="/static/qmsj/img/genjin/5.png" />
					<div class="num">{{list.hjjgj}}</div>
					<span class="txt">今日紧急跟进名单</span>
					<div class="left-top">会员</div>
				</div>
				<span @click="jump('vwangqigj')" style="position: absolute;top: 20px;right: 20px;color: white;">往期待跟进</span>
			</div>
		</div>

		<div class="right">
			<div class="right-box" @click="jump('qjinrigj')">
				<div class="name11">今日跟进名单</div>
				<span class="nums">{{list.qjrgj}}</span>
				<div class="titlefollow">潜客</div>
			</div>
			<div class="right-box" @click="jump('qjinrixz')" style="background: #00cce4;margin-bottom: 35px;">
				<div class="name11">今日新增名单</div>
				<span class="nums">{{list.qxzmd}}</span>
				<div class="titlefollow">潜客</div>
			</div>
			<div class="right-box" @click="jump('vjinrigj')">
				<div class="name11">今日跟进名单</div>
				<span class="nums">{{list.hjrgj}}</span>
				<div class="titlefollow">会员</div>
			</div>
			<div class="right-box" @click="jump('vjinrixz')" style="background: #00cce4;">
				<div class="name11">今日新增名单</div>
				<span class="nums">{{list.hxzmd}}</span>
				<div class="titlefollow">会员</div>
			</div>
		</div>
	</div>
</template>

<script>
	document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px'
	export default {
		data() {
			return {
				token: '',
				list: [],
				echarts1: [],
				echarts2: [],
			}
		},
		created() {
			let that = this
			that.token = that.$cookies.get('token');
			//	 	 	  列表数据
			$.ajax({
				url: process.env.apiUrl +'saas/qk/xz',
				type: 'post',
				data: {
					token: that.token
				},
				success: function(data, status) {
					that.list = data.data
				},
				fail: function(err, status) {
					console.log(err)
				}
			})
			//	 	 	 echarts柱状图一
			$.ajax({
				url: process.env.apiUrl +'saas/qk/qkzx',
				type: 'post',
				data: {
					token: that.token
				},
				success: function(data, status) {
					that.echarts1 = [data.data.zs, data.data.yx, data.data.ygj, data.data.ydd]
					that.echartsData1();
				},
				fail: function(err, status) {
					console.log(err)
				}
			});
			//	 	 	 echarts柱状图二
			$.ajax({
				url: process.env.apiUrl +'saas/qk/hyzx',
				type: 'post',
				data: {
					token: that.token
				},
				success: function(data, status) {
					that.echarts2 = [data.data.zs, data.data.yx, data.data.ygj, data.data.ydd]
					that.echartsData2();
				},
				fail: function(err, status) {
					console.log(err)
				}
			})
		},
		methods: {
			//	 	 	 路由跳转
			jump(r) {
				this.$router.push(r)
			},
			//	 	 	 echarts柱状图一
			echartsData1() {
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(document.getElementById('main'));
				// 指定图表的配置项和数据
				var option = {
					title: {
						text: ''
					},
					tooltip: {},
					legend: {
						data: ['']
					},
					xAxis: {
						data: ["总数", "有效", "已跟进", "已到店"],
						axisTick: {
							show: false
						},
						axisLine: {
							show: false
						}
					},
					yAxis: {
						show: false,
						splitLine: {
							show: false
						},
						splitArea: {
							show: false
						}
					},
					series: [{
						name: '潜客',
						type: 'bar',
						barWidth: 30,
						data: this.echarts1,
						itemStyle: {
							normal: {
								barBorderRadius: 10,
								color: function(params) {
									var colorList = [
										'#00cce4', '#f8e334', '#ffb97b', '#ff797c'
									];
									return colorList[params.dataIndex]
								}
							}
						}
					}]
				};
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
			},
			//           echarts柱状图二
			echartsData2() {
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(document.getElementById('main2'));
				// 指定图表的配置项和数据
				var option = {
					title: {
						text: ''
					},
					tooltip: {},
					legend: {
						data: []
					},
					xAxis: {
						data: ["总数", "有效", "已跟进", "已到店"],
						axisTick: {
							show: false
						},
						axisLine: {
							show: false
						}
					},
					yAxis: {
						show: false,
						splitLine: {
							show: false
						},
						splitArea: {
							show: false
						}
					},
					series: [{
						name: '会员',
						type: 'bar',
						barWidth: 30,
						data: this.echarts2,
						itemStyle: {
							normal: {
								barBorderRadius: 10,
								color: function(params) {
									var colorList = [
										'#00cce4', '#f8e334', '#ffb97b', '#ff797c'
									];
									return colorList[params.dataIndex]
								}
							}
						}
					}]
				};
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
			},
		}
	}
</script>

<style scoped="scoped" lang="less">
	#app {
		background: #ededed;
		font-size: 16px;
		padding: 15px;
	}
	.header {
		display: flex;
	}
	.left {
		display: inline-block;
		width: 78%;

		.top-box {
			display: inline-block;
			width: 19%;
			border-radius: 10px;
			height: 72px;
			margin-right: 5px;
			background: white;
			cursor: pointer;

			.top-txt {
				text-align: center;
				font-weight: bold;
				margin-top: 13px;
			}

			.down-txt {
				text-align: center;
				margin-top: 6px;
			}

			img {
				float: left;
				width: .4rem;
				height: .4rem;
				max-width: 40px;
				max-height: 40px;
				margin-top: .08rem;
				margin-left: .1rem;
			}

			span {
				margin-left: 15px;
			}
		}

		.three-box {
			display: inline-block;
			width: 59%;
			height: 210px;
			margin-top: 10px;
			margin-right: 10px;
			background: #fff;
			border-radius: 10px;
		}

		.two-box {
			display: inline-block;
			width: 37%;
			background: #a9d86e;
			height: 210px;
			margin-top: 10px;
			border-radius: 10px;
			float: right;
			margin-right: 18px;
			position: relative;
			overflow: hidden;
			cursor: pointer;

			.left-top {
				text-align: center;
				position: absolute;
				left: -30px;
				top: 20px;
				background: #fff;
				width: 33%;
				transform: rotate(-45deg);
			}

			img {
				margin-top: 50px;
				float: left;
				margin-left: 13.8%;
			}

			.num {
				position: absolute;
				top: 35px;
				left: 70%;
				display: inline-block;
				font-size: 100px;
				color: white;
			}

			.txt {
				display: inline-block;
				color: white;
				margin-left: 10px;
				position: absolute;
				bottom: 23px;
				left: 58%;
			}
		}
	}

	.right {
		float: right;
		width: 22%;
		margin-top: 50px;

		.right-box {
			width: 90%;
			margin: 0 auto 10px;
			height: 96px;
			border-radius: 10px;
			background: #ff797c;
			overflow: hidden;
			position: relative;
			cursor: pointer;

			.name11 {
				color: white;
				text-align: center;
				float: left;
				margin-left: 50px;
				margin-top: 53px;
			}

			.nums {
				font-size: 60px;
				color: white;
				margin-top: 10px;
				margin-left: 15px;
				display: inline-block;
			}

			.titlefollow {
				position: absolute;
				transform: rotate(40deg);
				right: -30px;
				top: 10px;
				width: 100px;
				background: #fff;
				text-align: center;
			}
		}

	}
	// .main {
	// 	width: 2.4rem;
	// 	height: 1.05rem;
	// 	padding-left: .25rem;
	// }
	.main {
		width: 100%;
		height: 210px;
	}
	@media screen and (max-width: 1030px) {
		.left .two-box {
			width: 36%;
		}
	}
	@media screen and (max-width: 600px) {
		#app {
			position: relative;
			font-size: .16rem;
		}
		.left {
			width: 100%;
			.two-box {
				float: unset;
				display: block;
				width: 78%;
			}
			.three-box {
				width: 100%;
			}
			.main {
				width: 100%;
			}
		}
		.right {
			position: absolute;
			right: .3rem;
			top: 326px;
			margin-top: unset;
			width: 18%;
		}
		.right  .right-box {
			width: 100%;
		}
		.right  .right-box:nth-child(3) {
			margin-top: 245px;
		}
		.right  .right-box .name11 {
			margin-left: unset;
			margin-top: unset;
			width: 20px;
			letter-spacing: 0;
			font-size: 12px;
			transform: scale(0.8);
		}
		.right  .right-box .nums {
			margin-left: unset;
		}
	}

</style>



// WEBPACK FOOTER //
// src/pages/genjin/follow.vue